import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import '../css/styles.css'
import { FaAngleRight } from 'react-icons/fa';
import { FaAngleLeft } from 'react-icons/fa';
import Tucson from '../assets/tucson.png'
import Kona from '../assets/kona.png'
import Staria from '../assets/staria.png'

const Step2 = ({ modeloVehiculo, onContinuar, modeloAgrupador, modeloVehiculoYear, codigoModeloYear, periodo, handleStepClick, activeKey, yearP, vin }) => {
    const [seleccionados, setSeleccionados] = useState(new Set());
    const [firstClick, setFirstClick] = useState(true);

    const yourBackFunction = () => {
        handleStepClick(1)
    };
    const mantenimientos5k = [
        { id: '1', label: '5.000 km' },
        { id: '2', label: '10.000 km' },
        { id: '3', label: '15.000 km' },
        { id: '4', label: '20.000 km' },
        { id: '5', label: '25.000 km' },
        { id: '6', label: '30.000 km' },
        { id: '7', label: '35.000 km' },
        { id: '8', label: '40.000 km' },
        { id: '9', label: '45.000 km' },
        { id: '10', label: '50.000 km' },
        { id: '11', label: '55.000 km' },
        { id: '12', label: '60.000 km' },
        { id: '13', label: '65.000 km' },
        { id: '14', label: '70.000 km' },
        { id: '15', label: '75.000 km' },
        { id: '16', label: '80.000 km' },
        { id: '17', label: '85.000 km' },
        { id: '18', label: '90.000 km' },
        { id: '19', label: '95.000 km' },
        { id: '20', label: '100.000 km' },
        { id: '21', label: '105.000 km' },
        { id: '22', label: '110.000 km' },
        { id: '23', label: '115.000 km' },
        { id: '24', label: '120.000 km' },
        { id: '25', label: '125.000 km' },
        { id: '26', label: '130.000 km' },
        { id: '27', label: '135.000 km' },
        { id: '28', label: '140.000 km' },
        { id: '29', label: '145.000 km' },
        { id: '30', label: '150.000 km' },
        { id: '31', label: '155.000 km' },
        { id: '32', label: '160.000 km' },
    ];

    const mantenimientos75k = [
        { id: '1', label: '7.500 km' },
        { id: '2', label: '15.000 km' },
        { id: '3', label: '22.500 km' },
        { id: '4', label: '30.000 km' },
        { id: '5', label: '37.500 km' },
        { id: '6', label: '45.000 km' },
        { id: '7', label: '52.500 km' },
        { id: '8', label: '60.000 km' },
        { id: '9', label: '67.500 km' },
        { id: '10', label: '75.000 km' },
        { id: '11', label: '82.500 km' },
        { id: '12', label: '90.000 km' },
        { id: '13', label: '97.500 km' },
        { id: '14', label: '105.000 km' },
        { id: '15', label: '112.500 km' },
        { id: '16', label: '120.000 km' },
        { id: '17', label: '127.500 km' },
        { id: '18', label: '135.000 km' },
        { id: '19', label: '142.500 km' },
        { id: '20', label: '150.000 km' },
        { id: '21', label: '157.500 km' },
    ];

    const mantenimientos10k = [
        { id: '1', label: '10.000 km' },
        { id: '2', label: '20.000 km' },
        { id: '3', label: '30.000 km' },
        { id: '4', label: '40.000 km' },
        { id: '5', label: '50.000 km' },
        { id: '6', label: '60.000 km' },
        { id: '7', label: '70.000 km' },
        { id: '8', label: '80.000 km' },
        { id: '9', label: '85.000 km' },
        { id: '10', label: '90.000 km' },
        { id: '11', label: '100.000 km' },
        { id: '12', label: '110.000 km' },
        { id: '13', label: '120.000 km' },
        { id: '14', label: '130.000 km' },
        { id: '15', label: '140.000 km' },
        { id: '16', label: '150.000 km' },
        { id: '17', label: '160.500 km' },
    ];

    const manejarCambio = (id) => {
        const newSelected = new Set(seleccionados);
        if (firstClick) {
            for (let i = 0; i < 4; i++) {
                if (newSelected.size < 10) {
                    newSelected.add(Number(id) + i);
                }
            }
            setFirstClick(false);
        } else {
            if (newSelected.has(Number(id))) {
                newSelected.delete(Number(id));
            } else {
                if (newSelected.size < 12) {
                    newSelected.add(Number(id));
                }
            }
        }
        setSeleccionados(newSelected);
    };


    const handleContinuarClick = () => {
        onContinuar(seleccionados);
    };

    const areConsecutive = (selectedIds) => {
        // Verificacion mantenimientos consecutivos
        const sortedIds = Array.from(selectedIds).sort((a, b) => a - b);

        for (let i = 0; i < sortedIds.length - 1; i++) {
            if (sortedIds[i + 1] - sortedIds[i] !== 1) {
                return false;
            }
        }
        return true;
    };

    let listaMantenimientos;

    if (periodo) {
        if(periodo === '5k')listaMantenimientos =  mantenimientos5k;
        if(periodo === '7k')listaMantenimientos =  mantenimientos75k;
        if(periodo === '10k')listaMantenimientos =  mantenimientos10k;
    } else {
        const { MP_VER_KM } = modeloVehiculoYear ? modeloVehiculoYear : modeloVehiculo.MP_VER_KM;
        if(MP_VER_KM === '5k')listaMantenimientos =  mantenimientos5k;
        if(MP_VER_KM === '7k')listaMantenimientos =  mantenimientos75k;
        if(MP_VER_KM === '10k')listaMantenimientos =  mantenimientos10k;
    }

    return (
        <div className="paso2">
            <Row >
                <Col sm={6} md={6} className='mantenaince order-2 order-md-1'>
                    <Row className='mt-4'>
                        <Col md={10} lg={10} className='form1'>
                            <div className="flex-container1">

                                <label className='textMantenaince ml-3 FontLight'>Selecciona los mantenimientos</label>
                            </div>
                            <Row className="row ml-1 mt-3">
                                {listaMantenimientos.map((mantenimiento) => (
                                    <Col xs={6} sm={6} md={5} lg={3} key={mantenimiento.id}>
                                        <div
                                            className={`checkbox-item ${seleccionados.has(Number(mantenimiento.id)) ? 'selected' : ''}`}
                                        >
                                            <Button
                                                variant={seleccionados.has(mantenimiento.id) ? "primary" : "outline-secondary"}
                                                className="fixed-width-button"
                                                id={mantenimiento.id}
                                                onClick={() => manejarCambio(mantenimiento.id)}
                                            >
                                                {mantenimiento.label}
                                            </Button>
                                        </div>
                                    </Col>
                                ))}
                            </Row>

                        </Col>

                    </Row>

                    <Row>
                        <Col xs={6} className="d-flex justify-content-between align-items-center mitems">
                            <Button
                                className='button-below2'
                                onClick={yourBackFunction}

                            >
                                <FaAngleLeft />
                                <span className='ml-1'>Regresar</span>

                            </Button>



                            <Button
                                variant="primary"
                                onClick={handleContinuarClick}
                                className='button-below3 '
                                disabled={!(seleccionados.size >= 4 && areConsecutive(seleccionados))}
                                style={
                                    !(seleccionados.size >= 4 && areConsecutive(seleccionados))
                                        ? { backgroundColor: '#D3D3D3', color: '#808080', border: 'none' }
                                        : {}
                                }
                            >
                                <div className='d-flex align-items-center'>
                                    <span className=' ml-3'>Continuar</span>
                                    <FaAngleRight style={{ marginLeft: '10px' }} />
                                </div>
                            </Button>
                        </Col>
                    </Row>
                </Col>


                <Col sm={6} md={6} className="text-center order-1 order-md-2">
                    <Col>
                        {modeloVehiculo && modeloVehiculo.imagen && (
                            <div className="car-image-container car-container-margin">
                                <img
                                    src={
                                        modeloVehiculo.imagen.startsWith('https://kerner.hyundai.com.ec/images/colores/')
                                            ? modeloVehiculo.imagen.replace('https://kerner.hyundai.com.ec/images/colores/', '/colores/')
                                        : modeloVehiculo.imagen.startsWith('https://kerner.hyundai.com.ec/images/spincar360/')
                                            ? modeloVehiculo.imagen.replace('https://kerner.hyundai.com.ec/images/spincar360/', '/spincar360/')
                                        : modeloVehiculo.imagen.startsWith('/static/media/')
                                            ? modeloVehiculo.imagen.replace('/static/media/', '/colores/')
                                        : modeloVehiculo.imagen.startsWith('https://www.hyundai.com.ec/static/media/')
                                            ? modeloVehiculo.imagen.replace('https://www.hyundai.com.ec/static/media/', '/colores/')
                                        : modeloVehiculo.imagen
                                    }
                                    alt="Carro"
                                    className="car-image car-image-step2"
                                />
                                <div className="car-model-description2">
                                    <div className='column'>
                                        <span className='texttitle'>Marca:</span>
                                        <span className='modeltext'> Hyundai</span>
                                    </div>
                                    <div className='column'>
                                        <span className='texttitle'>Modelo de Vehiculo:</span>
                                        <span className='modeltext'> {modeloAgrupador}</span>
                                    </div>
                                    {activeKey === 'placa' && (
                                        <div className="column">
                                            <span className='texttitle'>Año:</span>
                                            {modeloAgrupador && <span className='modeltext'> {yearP}</span>}
                                        </div>
                                    )}
                                    {activeKey === 'placa' && (
                                        <div className="column">
                                            <span className='texttitle' >VIN: </span>
                                            <span className='modeltext'>{vin}</span>
                                        </div>
                                    )}
                                </div>
                                <div className="blue-background" />
                            </div>
                        )}
                    </Col>
                </Col>


            </Row>
        </div>
    );
};

export default Step2;